/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import LazyLoad from 'vanilla-lazyload';
import BackToTop from "./Classes/BackToTop";
import MenuChild from "./Classes/MenuChild";
import SideNav from "./Classes/SideNav";
import Accordion from './Classes/Accordion';
import Highlights from "./Classes/Highlights";
import ResponsiveTable from "./Classes/ResponsiveTable";
import FocusHandler from "./Classes/FocusHandler";
import LinkHandler from "./Classes/LinkHandler";
import Slider from './Classes/Slider';


var lazyLoadInstance = null;
var focusHandlerInstance = null;
var backToTopInstance = null;
var sideNavInstance = null;
var menuChild = null;
var accordionInstance = null;
var accordionWpInstance = null;
var highlightsInstance = null;
var responsiveTableInstance = null;
var linkHandlerInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  focusHandlerInstance = new FocusHandler();

  menuChild = new MenuChild();

  sideNavInstance = new SideNav({
    sideNavTitles: '.ns-title-h2.side-nav, .ns-title-h3.side-nav'
  });

  backToTopInstance = new BackToTop({
    buttonClass: '.js-backtotop-toggle',
    stickyClass: '.prev-next__inner',
    fadeInPosition: 100,
    correction: 0,
    toolbarClass: '.js-backtotop-toggle'
  });

  accordionInstance = new Accordion( {
    accordions: '.ns-accordion',
    pxCorrection: 0
  });


  accordionWpInstance = new Accordion( {
    accordions: '.wp-accordion',
    pxCorrection: 0
  });

  highlightsInstance = new Highlights({
    container: '.ns-timeline',
    title: '.ns-timeline__title',
    toggler: '.ns-paragraph--more'
  });

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });

  linkHandlerInstance = new LinkHandler();
  new Slider();
});
